export { default as AuthenticatedRoute } from './AuthenticatedRoute'
export { default as GuestRoute } from './GuestRoute'
import { createBrowserHistory } from 'history'

let history = createBrowserHistory()
export default history
